import React from "react";

import { Box, Typography } from "@mui/material";

import { EditableField } from "./EditableField";

interface SectionBreakHeaderProps {
  title: string;
  onTitleChange: (title: string) => void;
  readOnly?: boolean;
}

export const SectionBreakHeader: React.FC<SectionBreakHeaderProps> = ({ title, onTitleChange, readOnly }) => {
  return (
    <Box
      sx={{
        bgcolor: "#071f35",
        p: "48px 48px 36px",
        display: "flex",
        alignItems: "flex-end"
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontSize: 10,
            fontWeight: 700,
            color: "rgba(255,255,255,0.45)",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            mb: 1
          }}
        >
          Section
        </Typography>
        <EditableField
          value={readOnly && !title ? "Untitled Section" : title}
          placeholder="Section title"
          onSave={onTitleChange}
          readOnly={readOnly}
          style={{ fontSize: 28, fontWeight: 700, color: "#FFFFFF", lineHeight: 1.25 }}
        />
      </Box>
    </Box>
  );
};
